import { useEffect, useState } from "react";
import { saveProjectDetails } from "../Api/ProjectMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import {
  fetchCustomersByOrgId,
  fetchProjectTypes,
  fetchResourceByOrgId,
  fetchCompanyCodesById,
} from "../Api/InvoiceApi";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { Base_URL } from "../url";

const ProjectMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;

  const [customer, setCustomer] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [resource, setResource] = useState([]);
  const [company, setCompany] = useState([]);
  const [status, setStatus] = useState([]);

  const { user } = useAuth();

  const [projectData, setProjectData] = useState({
    prTitle: "",
    prDescription: "",
    prTags: "",
    prStartDate: "",
    prEndDate: "",
    prClient: "",
    prTypes: "",
    usersId: String(userId) || "",
    orgId: String(orgId) || "",
    teamAssigned: "",
    projectStatus: "",
    projectCategory: "",
    comments: "",
    salespersonCode: "",
    currentProjectManager: "",
    organisationId: user?.organisationId,
    companyCode: "",
    projectPriority: "", // ✅ new field
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchDropdownData = async () => {
    try {
      const res = await fetchCustomersByOrgId(user?.organisationId);
      const res1 = await fetchProjectTypes(user?.organisationId);
      const res2 = await fetchResourceByOrgId(user?.organisationId);
      const res3 = await fetchCompanyCodesById(user?.organisationId);
      const res4 = await axios.get(`${Base_URL}/ProjectStatus`);

      setCustomer(res || []);
      setProjectType(res1 || []);
      setResource(res2 || []);
      setCompany(res3 || []);
      setStatus(res4.data || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      setCustomer([]);
      setProjectType([]);
      setResource([]);
      setCompany([]);
      setStatus([]);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveProjectDetails(projectData, userId);
      toast.success("🦄 Project Added Successfully");
      console.log(projectData);
      // Reset form after successful submission
      setProjectData({
        prTitle: "",
        prDescription: "",
        prTags: "",
        prStartDate: "",
        prEndDate: "",
        prClient: "",
        prTypes: "",
        usersId: String(userId) || "",
        orgId: String(orgId) || "",
        teamAssigned: "",
        projectStatus: "",
        projectCategory: "",
        comments: "",
        salespersonCode: "",
        currentProjectManager: "",
        organisationId: user?.organisationId,
        companyCode: "",
        projectPriority: "", // ✅ reset field
      });

      navigate("/viewProjects");
    } catch (error) {
      toast.error(`🦄 Error saving project: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Project Master</h2>

        {loading && (
          <div className="loading-overlay">
            <Sample14 />
          </div>
        )}

        <Form onSubmit={handleSubmit} className="fields-form">
          {/* ---- Company Code ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Company Code <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="companyCode"
                  value={projectData.companyCode}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Company Code</option>
                  {company.map((p) => (
                    <option key={p.companyCode} value={p.companyCode}>
                      {p.companyCode} - {p.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Category <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="projectCategory"
                  value={projectData.projectCategory}
                  onChange={(e) => {
                    const value = e.target.value;
                    setProjectData((prev) => ({
                      ...prev,
                      projectCategory: value,
                      // 🔹 Clear these if Internal is selected
                      prClient: value === "Internal" ? "" : prev.prClient,
                      salespersonCode:
                        value === "Internal" ? "" : prev.salespersonCode,
                    }));
                  }}
                  required
                >
                  <option value="">Select Category</option>
                  <option value="Internal">Internal</option>
                  <option value="External">External</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Basic Details ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Title <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="prTitle"
                  value={projectData.prTitle}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Description <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="prDescription"
                  value={projectData.prDescription}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Project Tags</Form.Label>
                <Form.Control
                  type="text"
                  name="prTags"
                  value={projectData.prTags}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Dates ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Start Date <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="prStartDate"
                  value={projectData.prStartDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  End Date <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="prEndDate"
                  value={projectData.prEndDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {projectData.projectCategory !== "Internal" && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Client Code <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Select
                    name="prClient"
                    value={projectData.prClient}
                    onChange={handleChange}
                    required={projectData.projectCategory === "External"}
                    disabled={!user?.organisationId}
                  >
                    <option value="">Select Client Code</option>
                    {customer.map((c) => (
                      <option key={c.customerCode} value={c.customerCode}>
                        {c.customerCode} - {c.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
          </Row>

          {/* ---- Type, Team, Priority ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Type <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="prTypes"
                  value={projectData.prTypes}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Project Type</option>
                  {projectType.map((p) => (
                    <option key={p.projectTypeId} value={p.projectTypeId}>
                      {p.projectTypeId} - {p.projectTypeDesc}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Team Assigned</Form.Label>
                <Form.Control
                  type="text"
                  name="teamAssigned"
                  value={projectData.teamAssigned}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            {/* ✅ New Dropdown for Project Priority */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Priority <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="projectPriority"
                  value={projectData.projectPriority}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Priority</option>
                  <option value="Very High">Very High</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Remaining Fields ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Status <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="projectStatus"
                  value={projectData.projectStatus}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Project Status</option>
                  {status.map((p) => (
                    <option key={p.projectStatusId} value={p.projectStatusId}>
                      {p.projectStatusId} - {p.projectStatusDesc}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Comments</Form.Label>
                <Form.Control
                  type="text"
                  name="comments"
                  value={projectData.comments}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {projectData.projectCategory !== "Internal" && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Salesperson Code <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Select
                    name="salespersonCode"
                    value={projectData.salespersonCode}
                    onChange={handleChange}
                    required={projectData.projectCategory === "External"}
                    disabled={!user?.organisationId}
                  >
                    <option value="">Select SalesPerson Code</option>
                    {resource.map((r) => (
                      <option key={r.resourceId} value={r.resourceId}>
                        {r.resourceId} - {r.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Manager <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="currentProjectManager"
                  value={projectData.currentProjectManager}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Project Manager</option>
                  {resource.map((r) => (
                    <option key={r.resourceId} value={r.resourceId}>
                      {r.resourceId} - {r.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Submit ---- */}
          <div className="fields-btn-container">
            <Button
              variant="primary"
              type="submit"
              className="fields-submit"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Project"}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default ProjectMaster;

// import { useEffect, useState } from "react";
// import { saveProjectDetails } from "../Api/ProjectMaster";
// import { Container, Form, Button, Row, Col } from "react-bootstrap";

// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import Sample14 from "../Components/Logo";
// import {
//   fetchCustomersByOrgId,
//   fetchProjectTypes,
//   fetchResourceByOrgId,
//   fetchCompanyCodesById,
// } from "../Api/InvoiceApi";
// import { useAuth } from "../Context/AuthContext";
// import axios from "axios";
// import { Base_URL } from "../url";

// const ProjectMaster = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
//   const userId = userDetails?.userId;
//   const orgId = userDetails?.organisationId;

//   const [customer, setCustomer] = useState([]);
//   const [projectType, setProjectType] = useState([]);
//   const [resource, setResource] = useState([]);
//   const [company, setCompany] = useState([]);
//   const [status, setStatus] = useState([]);

//   const { user } = useAuth();

//   const [projectData, setProjectData] = useState({
//     prTitle: "",
//     prDescription: "",
//     prTags: "",
//     prStartDate: "",
//     prEndDate: "",
//     prClient: "",
//     prTypes: "",
//     usersId: String(userId) || "",
//     orgId: String(orgId) || "",
//     teamAssigned: "",
//     projectStatus: "",
//     projectCategory: "",
//     comments: "",
//     salespersonCode: "",
//     currentProjectManager: "",
//     organisationId: user?.organisationId,
//     companyCode: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProjectData((prev) => ({ ...prev, [name]: value }));
//   };

//   const fetchDropdownData = async () => {
//     try {
//       const res = await fetchCustomersByOrgId(user?.organisationId);
//       const res1 = await fetchProjectTypes(user?.organisationId);
//       const res2 = await fetchResourceByOrgId(user?.organisationId);
//       const res3 = await fetchCompanyCodesById(user?.organisationId);
//       const res4 = await axios.get(`${Base_URL}/ProjectStatus`);

//       console.log("Company codes response:", res3); // Debug log

//       setCustomer(res || []);
//       setProjectType(res1 || []);
//       setResource(res2 || []);
//       setCompany(res3 || []); // This should now be an array
//       setStatus(res4.data || []);
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//       // Set empty arrays to prevent map errors
//       setCustomer([]);
//       setProjectType([]);
//       setResource([]);
//       setCompany([]);
//       setStatus([]);
//     }
//   };

//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await saveProjectDetails(projectData, userId);
//       toast.success("🦄 Project Added Successfully");

//       // Reset while preserving usersId/orgId/organisationId
//       setProjectData({
//         prTitle: "",
//         prDescription: "",
//         prTags: "",
//         prStartDate: "",
//         prEndDate: "",
//         prClient: "",
//         prTypes: "",
//         usersId: String(userId) || "",
//         orgId: String(orgId) || "",
//         teamAssigned: "",
//         projectStatus: "",
//         projectCategory: "",
//         comments: "",
//         salespersonCode: "",
//         currentProjectManager: "",
//         organisationId: user?.organisationId,
//         companyCode: "",
//       });

//       navigate("/viewProjects");
//     } catch (error) {
//       toast.error(`🦄 Error saving project: ${error.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="main-content expand">
//       <Container fluid className="fields-container">
//         <h2 className="fields-title">Project Master</h2>

//         {loading && (
//           <div className="loading-overlay">
//             <Sample14 />
//           </div>
//         )}

//         <Form onSubmit={handleSubmit} className="fields-form">
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Company Code <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="companyCode"
//                   value={projectData.companyCode}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Company Code</option>
//                   {company.map((p) => (
//                     <option key={p.companyCode} value={p.companyCode}>
//                       {p.companyCode} - {p.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Title <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prTitle"
//                   value={projectData.prTitle}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Description <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prDescription"
//                   value={projectData.prDescription}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Project Tags</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prTags"
//                   value={projectData.prTags}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Start Date <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="date"
//                   name="prStartDate"
//                   value={projectData.prStartDate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   End Date <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="date"
//                   name="prEndDate"
//                   value={projectData.prEndDate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Client Code <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="prClient"
//                   value={projectData.prClient}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Client Code</option>
//                   {customer.map((c) => (
//                     <option key={c.customerCode} value={c.customerCode}>
//                       {c.customerCode} - {c.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Type <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="prTypes"
//                   value={projectData.prTypes}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Project Type</option>
//                   {projectType.map((p) => (
//                     <option key={p.projectTypeId} value={p.projectTypeId}>
//                       {p.projectTypeId} - {p.projectTypeDesc}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Team Assigned</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="teamAssigned"
//                   value={projectData.teamAssigned}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Status <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="projectStatus"
//                   value={projectData.projectStatus}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Project Status</option>
//                   {status.map((p) => (
//                     <option key={p.projectStatusId} value={p.projectStatusId}>
//                       {p.projectStatusId} - {p.projectStatusDesc}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Category</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="projectCategory"
//                   value={projectData.projectCategory}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Comments</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="comments"
//                   value={projectData.comments}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Salesperson Code</Form.Label>
//                 <Form.Select
//                   name="salespersonCode"
//                   value={projectData.salespersonCode}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select SalesPerson Code</option>
//                   {resource.map((r) => (
//                     <option key={r.resourceId} value={r.resourceId}>
//                       {r.resourceId} - {r.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Manager <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="currentProjectManager"
//                   value={projectData.currentProjectManager}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Project Manager</option>
//                   {resource.map((r) => (
//                     <option key={r.resourceId} value={r.resourceId}>
//                       {r.resourceId} - {r.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="fields-btn-container">
//             <Button
//               variant="primary"
//               type="submit"
//               className="fields-submit"
//               disabled={loading}
//             >
//               {loading ? "Saving..." : "Save Project"}
//             </Button>
//           </div>
//         </Form>
//       </Container>
//     </div>
//   );
// };

// export default ProjectMaster;
